export interface DebugPanelProps {
  values: Record<string, string | number | boolean | null | undefined>;
  onClose: () => void;
}

/**
 * A state readout for bugs that only happen inside Teams.
 *
 * Follow mode cannot be exercised locally — DevLiveShareBridge is in-memory and
 * tab-local — so every question about it has been answered by deploying a guess
 * and asking someone with a phone. That cost several rounds on 2026-08-27. This
 * is the project's own documented remedy: ship a readout, and let one look at
 * the screen replace an afternoon of inference.
 *
 * Hidden unless deliberately summoned (five taps on the wordmark), so it cannot
 * turn up in a certification screenshot.
 */
export function DebugPanel({ values, onClose }: DebugPanelProps) {
  return (
    <div className="debug-panel" role="status">
      <div className="debug-panel__head">
        <strong>state</strong>
        <button onClick={onClose} aria-label="Hide diagnostics">
          &times;
        </button>
      </div>
      {Object.entries(values).map(([k, v]) => (
        <div className="debug-panel__row" key={k}>
          <span className="debug-panel__key">{k}</span>
          <span className="debug-panel__val">{v === undefined ? '—' : String(v)}</span>
        </div>
      ))}
    </div>
  );
}
